import { LandingEvalDemo } from "@/components/landing-eval-demo";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/landing-eval-demo")({
  component: RouteComponent,
});

function RouteComponent() {
  return <LandingEvalDemo />;
}
